import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Input,
  Radio,
  Empty,
  Checkbox,
  notification,
} from 'antd'
import GGEditor, { Flow } from 'gg-editor'
import EditorMinimap from './flow/EditorMinimap'
import { FlowToolbar } from './flow/EditorToolbar'
import { FlowItemPanel } from './flow/EditorItemPanel'
import { FlowContextMenu } from './flow/EditorContextMenu'
import { LeftOutlined, ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons'

import styled from 'styled-components'
import CustomNodeRect from './flow/CustomNodeRect'
import CustomNodeRhombus from './flow/CustomNodeRhombus'

import {
  getChart,
  postChart,
  updateChart,
  deleteChart,
  postSpintflowinit,
  getResultProjectList,
  getChartSource,
  getChartTarget,
  copyTask,
  checkCompleteFlow,
  getFlowCheckDate,
} from '../../../api/Project/sprintFlow'

import lang from 'lang/en'

GGEditor.setTrackable(false)
import { getCookie, setCookie } from 'helper/cookie'
import { isMobile } from 'react-device-detect'
const initalState = {
  data: [],
  isLoading: true,
  detailItem: {
    id_chart: '',
    label: '',
    type_chart: '',
    shape: '',
    color: '',
    axis_x: 0,
    axis_y: 0,
    size: '',
  },
  detailLine: {
    id_chart: '',
    label: '',
    type_chart: '',
    source: '',
    sourceAnchor: '',
    target: '',
    targetAnchor: '',
  },
}

//url
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'

import NoPermissionSprint from 'common/SprintTaskFlow/NoPermissionSprint'
import { lowerCase } from 'lodash'

const MapChartContainer = styled.div`
 margin:-32px;
 position:relative;
 display:flex;
 justify-content:flex-end;
 .box-message-spritflow{
  margin:8px;
  background-color:#FFFBE6;
  border:1px solid #FFE58F;
  padding:12px;
  border-radius: 2px;
  display:flex;
  flex-direction:column;
  position:absolute;
  .rbms{
    align-items:center;
    .anticon{
      color:#FFAF00;
      font-size:20px;
      margin-right:8px;
    }
  }
  .title-err-flow{
    font-family: 'IBMPlexSansThaiRegular';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
  }
  .item-text{
    font-family: 'IBMPlexSansThaiRegular';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    padding-left:28px;
  }
 }
`

const TaskFlow = (props) => {
  const language = getCookie('lang')
  const word = lang[language]

  const checkMobileView = isMobile

  const { swithCaseFunction } = props
  const { swithCaseTaskFLowFunction } = props
  const {
    funcsetIdChart,
    role,
    idEditPRJ,
    setStatusTask,
    canSprintTaskFlow,
    setCheckDecision,
    setCheckChangeFlow,
    checkPlandateTaskSubTask,
    setWordErrFlow,
    setFullyCheckCompleteInCommon,
    statusProject
  } = props

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  let roleUser = parseInt(getCookie('roleUser'))
  const [dataChart, setDataChart] = useState([])

  const [ModalVision, setModalVision] = useState(false)
  const [ModalVisionLine, setModalVisionLine] = useState(false)
  const [ModalVisionLine2, setModalVisionLine2] = useState(false)

  const [form] = Form.useForm()
  const [form2] = Form.useForm()
  const [form3] = Form.useForm()

  const [additem, setAddItem] = useState(initalState.detailItem)

  const [addLine, setAddLine] = useState(initalState.detailLine)

  const [fieldNameLine, setFieldNameLine] = useState()

  //dataSourceChart
  const [dataSourceChart, setDataSourceChart] = useState(initalState.data)
  const [disableRadio, setDisableRadio] = useState(false)

  //url
  const history = useHistory()
  const { id } = useParams()
  const [checkLanding, setCheckLanding] = useState(false)

  //checkstateLine
  const [stateLine, setStateLine] = useState()

  //checkchart
  const [checkStartEnd, setCheckStartEnd] = useState(false)
  // const [checkTaskHaveLine, setCheckTaskHaveLine] = useState(0)

  const [checkTask200, setCheckTask200] = useState(false)
  const [checkTask400, setCheckTask400] = useState(false)

  const [checkDecision200, setCheckDecision200] = useState(false)
  const [checkDecision400, setCheckDecision400] = useState(false)

  const [checkDecision2200, setCheckDecision2200] = useState(false)
  const [checkDecision2400, setCheckDecision2400] = useState(false)

  const [checkHaveDecision, setCheckHaveDecision] = useState(false)

  const [errrr, serErrrr] = useState([])
  const [listErrorflow, setListErrorFlow] = useState([])


  const [visibleModalCheckSubtask, setVisibleModalCheckSubtask] = useState(false)

  //url
  const urlPage = window.location.href

  const checkLandingPage = () => {
    const split = urlPage.split('/')
    let landing = ''

    if (split[6]) {
      landing = split[6]
      if (landing !== '') {
        getResultProjectList({
          project_id: parseInt(idEditPRJ),
          id_chart: landing,
          token: token,
        })
          .then(async (response) => {
            const { status, data, error } = response

            if (error) {
              props.setCode([])

              setIsLoading(false)
              return true
            }
            if (status === 200) {
              props.setCode(data.code)
              setCheckDecision(data.shape_chart)
              setIsLoading(false)
              funcsetIdChart(landing)
              swithCaseTaskFLowFunction('addtask')
            } else {
              props.setCode([])
              setIsLoading(false)
              return true
            }
          })
          .catch((error) => {
            props.setCode([])
            setIsLoading(false)
            console.error(error)
          })
      }

      setCheckLanding(true)
    }
  }
  useEffect(() => {
    if (checkLanding === false) {
      checkLandingPage()
      // console.log('เข้า use 1')
      // getChartData()
    }
  }, [urlPage])

  const getChartData = async () => {
    checkPlandateTaskSubTask()
    setFieldNameLine(getCookie('wordLine'))
    setCheckTask400(false)
    setCheckDecision400(false)
    setCheckDecision200(false)
    setCheckDecision2200(false)
    setCheckDecision2400(false)
    setCheckHaveDecision(false)
    serErrrr([])
    // console.log('getChartData')

    await getChart({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setIsLoading(false)
          return true
        }

        if (status === 200) {
          //เช็คว่ามี start กับ end
          let checkStart = false
          let checkEnd = false
          data.nodes.map((item) => {
            if (item.label == 'Start') {
              checkStart = true
            }
            if (item.label == 'End') {
              checkEnd = true
            }
          })
          let a = false
          if (checkStart == true && checkEnd == true) {
            a = true
          } else {
            a = false
          }
          if (checkStart == false) {
            serErrrr((prev) => [...prev, 'Please check start point'])
          }
          if (checkEnd == false) {
            serErrrr((prev) => [...prev, 'Please check end point'])
          }

          // เช็คว่า start มีเส้นออกมั้ย กับ end มีเส้นเข้ามั้ย
          let checkLineStart = false
          let checkLineEnd = false
          data.nodes.map((item) => {
            if (data.edges != null) {
              if (item.label == 'Start') {
                data.edges.map((item2) => {
                  if (item.id == item2.source) {
                    checkLineStart = true
                  }
                })
              }
              if (item.label == 'End') {
                data.edges.map((item2) => {
                  if (item.id == item2.target) {
                    checkLineEnd = true
                  }
                })
              }
            } else {
              checkLineStart = false
              checkLineEnd = false
            }
          })
          let b = false
          if (checkLineStart == true && checkLineEnd == true) {
            b = true
          } else {
            b = false
          }

          if (checkLineStart == false) {
            if (checkStart == true) {
              serErrrr((prev) => [...prev, 'Please check connector'])
            }
          }
          if (checkLineEnd == false) {
            if (checkEnd == true) {
              serErrrr((prev) => [...prev, 'Please check connector'])
            }
          }

          //เช็ครวม
          if (a == true && b == true) {
            setCheckStartEnd(true)
          } else {
            setCheckStartEnd(false)
          }

          //เช็คว่า task นั้นมีเส้นออกหรือเข้ามั้ย
          data.nodes.map((item) => {
            if (item.shape != 'flow-circle') {
              if (item.shape == 'flow-rect') {
                getChartSource({
                  id_chart: item.id,
                  project_id: parseInt(idEditPRJ),
                  token: token,
                })
                  .then(async (response) => {
                    const { status, data, error } = response

                    if (error) {
                      setIsLoading(false)
                      return true
                    }
                    if (status === 200) {
                      setCheckTask200(true)
                    } else {
                      serErrrr((prev) => [...prev, 'Please check connector'])
                      setCheckTask400(true)
                    }
                  })
                  .catch((error) => {
                    setIsLoading(false)
                    console.error(error)
                  })
              } else {
                //เช็คว่า decision นั้นมีเส้นออกทั้ง 2 เส้นมั้ย
                setCheckHaveDecision(true)
                getChartSource({
                  id_chart: item.id,
                  project_id: parseInt(idEditPRJ),
                  token: token,
                })
                  .then(async (response) => {
                    const { status, data, error } = response

                    if (error) {
                      setIsLoading(false)
                      return true
                    }
                    if (status === 200) {
                      if (data.length == 2 || data.length == 3) {
                        setCheckDecision200(true)
                        setCheckDecision2200(true)
                      } else {
                        serErrrr((prev) => [
                          ...prev,
                          'Please check connector for decision',
                        ])
                        setCheckDecision2400(true)
                      }
                    } else {
                      serErrrr((prev) => [...prev, 'Please check connector for decision'])
                      setCheckDecision400(true)
                    }
                  })
                  .catch((error) => {
                    setIsLoading(false)
                    console.error(error)
                  })
              }
            }
          })
          setDataChart(data)
          setIsLoading(false)
        } else {
          serErrrr((prev) => [...prev, 'ไม่มี task'])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        serErrrr((prev) => [...prev, 'ไม่มี task'])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    setWordErrFlow(errrr)
  }, [errrr])

  useEffect(() => {
    if (token) {
      // console.log('เข้า use 2')
      getChartData()
    }
  }, [token])

  const openNotificationWithIcon = (type, word) => {
    notification[type]({
      message: 'Error',
      description: word,
      duration: 3,
    })
  }

  const onAfterChange = (e) => {

    getChart({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setIsLoading(false)
          if (role === true) {
          } else {
            if (e.action == 'add') {
              if (e.item.model.type == null) {
                if (e.item.source.id != e.item.target.id) {
                  if (
                    e.item.source.model.label == 'End' &&
                    e.item.source.model.shape == 'flow-circle'
                  ) {
                    openNotificationWithIcon(
                      'error',
                      `End point can't draw a line out of it.`,
                    )

                    getChartData()
                  } else {
                    setStateLine('Add')
                    setDataLineSendBack(e)
                    let IDSourceChart = e.item.source.id
                    if (e.item.source.model.shape == 'flow-rhombus') {
                      getChartSource({
                        id_chart: IDSourceChart,
                        project_id: parseInt(idEditPRJ),
                        token: token,
                      })
                        .then(async (response) => {
                          const { status, data, error } = response

                          if (error) {
                            setDataSourceChart([])

                            setIsLoading(false)
                            return true
                          }
                          if (status === 200) {
                            if (data.length == 1) {
                              setDisableRadio(true)
                              data.map((item) => {
                                if (item.label == 'Approve') {
                                  form2.setFieldsValue({
                                    nameline: 'Reject',
                                  })
                                } else {
                                  form2.setFieldsValue({
                                    nameline: 'Approve',
                                  })
                                }

                                if (item.target == e.item.target.id) {
                                  openNotificationWithIcon(
                                    'error',
                                    `Can't add lines because draw a line to find the same place that used to exist.`,
                                  )
                                  getChartData()
                                } else {
                                  setAddLine((prevState) => {
                                    return {
                                      ...prevState,
                                      id_chart: e.item.model.id,
                                      type_chart: 'line',
                                      source: e.item.model.source,
                                      sourceAnchor: e.item.model.sourceAnchor,
                                      target: e.item.model.target,
                                      targetAnchor: e.item.model.targetAnchor,
                                    }
                                  })
                                  setModalVisionLine(true)
                                }
                              })
                            } else if (data.length >= 2) {
                              checkSendBack(e)
                            } else {
                              getChartData()
                            }
                            setDataSourceChart(data)
                            setIsLoading(false)
                          } else {
                            setDisableRadio(false)
                            setAddLine((prevState) => {
                              return {
                                ...prevState,
                                id_chart: e.item.model.id,
                                type_chart: 'line',
                                source: e.item.model.source,
                                sourceAnchor: e.item.model.sourceAnchor,
                                target: e.item.model.target,
                                targetAnchor: e.item.model.targetAnchor,
                              }
                            })
                            setModalVisionLine(true)
                            setDataSourceChart([])

                            setIsLoading(false)
                            return true
                          }
                        })
                        .catch((error) => {
                          setDataSourceChart([])
                          setIsLoading(false)
                          console.error(error)
                        })
                    } else if (e.item.source.model.shape == 'flow-rect') {
                      getChartSource({
                        id_chart: IDSourceChart,
                        project_id: parseInt(idEditPRJ),
                        token: token,
                      })
                        .then(async (response) => {
                          const { status, data, error } = response

                          if (error) {
                            setDataSourceChart([])

                            setIsLoading(false)
                            return true
                          }
                          if (status === 200) {
                            if (data.length == 1) {
                              //deletesendback
                              if (data[0].label == 'Review') {
                                if (data[0].target == e.item.model.target) {
                                  openNotificationWithIcon(
                                    'error',
                                    `Task can't draw target same task.`,
                                  )
                                  getChartData()
                                } else {
                                  setAddLine((prevState) => {
                                    return {
                                      ...prevState,
                                      id_chart: e.item.model.id,
                                      type_chart: 'line',
                                      source: e.item.model.source,
                                      sourceAnchor: e.item.model.sourceAnchor,
                                      target: e.item.model.target,
                                      targetAnchor: e.item.model.targetAnchor,
                                    }
                                  })
                                  setModalVisionLine2(true)
                                  setDataSourceChart([])
                                  setIsLoading(false)
                                  setCheckRealSendBack(true)
                                  return true
                                }
                              } else {
                                checkSendBack(e)
                              }
                            } else if (data.length > 1) {
                              openNotificationWithIcon(
                                'error',
                                `Task can't draw additional lines.`,
                              )
                              getChartData()
                            }
                            setDataSourceChart(data)
                            setIsLoading(false)
                          } else {
                            setCheckRealSendBack(true)
                            setAddLine((prevState) => {
                              return {
                                ...prevState,
                                id_chart: e.item.model.id,
                                type_chart: 'line',
                                source: e.item.model.source,
                                sourceAnchor: e.item.model.sourceAnchor,
                                target: e.item.model.target,
                                targetAnchor: e.item.model.targetAnchor,
                              }
                            })
                            setModalVisionLine2(true)
                            setDataSourceChart([])
                            setIsLoading(false)
                            return true
                          }
                        })
                        .catch((error) => {
                          setDataSourceChart([])
                          setIsLoading(false)
                          console.error(error)
                        })
                    } else if (e.item.source.model.shape == 'flow-circle') {
                      getChartSource({
                        id_chart: IDSourceChart,
                        project_id: parseInt(idEditPRJ),
                        token: token,
                      })
                        .then(async (response) => {
                          const { status, data, error } = response

                          if (error) {
                            setDataSourceChart([])

                            setIsLoading(false)
                            return true
                          }
                          if (status === 200) {
                            if (data.length >= 1) {
                              openNotificationWithIcon(
                                'error',
                                'Start point has only one line.',
                              )

                              getChartData()
                            }
                            setDataSourceChart(data)
                            setIsLoading(false)
                          } else {
                            setAddLine((prevState) => {
                              return {
                                ...prevState,
                                id_chart: e.item.model.id,
                                type_chart: 'line',
                                source: e.item.model.source,
                                sourceAnchor: e.item.model.sourceAnchor,
                                target: e.item.model.target,
                                targetAnchor: e.item.model.targetAnchor,
                              }
                            })
                            setCheckRealSendBack(true)
                            setModalVisionLine2(true)
                            setDataSourceChart([])
                            setIsLoading(false)
                            return true
                          }
                        })
                        .catch((error) => {
                          setDataSourceChart([])
                          setIsLoading(false)
                          console.error(error)
                        })
                    } else {
                      setAddLine((prevState) => {
                        return {
                          ...prevState,
                          id_chart: e.item.model.id,
                          type_chart: 'line',
                          source: e.item.model.source,
                          sourceAnchor: e.item.model.sourceAnchor,
                          target: e.item.model.target,
                          targetAnchor: e.item.model.targetAnchor,
                        }
                      })
                      setModalVisionLine2(true)
                    }
                  }
                } else {
                  openNotificationWithIcon(
                    'error',
                    'Unable to draw a line towards itself.',
                  )
                  getChartData()
                }
              } else {
                let checkCopy = false
                let countcopy = false
                if (data != '') {
                  data.nodes.map((item) => {
                    if (item.label == e.model.label && countcopy == false) {
                      //เช็คเงื่อนไขว่า ถ้าเป็น start กับ end ไม่่ต้องเช็ค copy
                      if (e.model.shape != 'flow-circle') {
                        countcopy = true
                        checkCopy = true
                      }

                      getResultProjectList({
                        project_id: parseInt(idEditPRJ),
                        id_chart: item.id,
                        token: token,
                      })
                        .then(async (response) => {
                          const { status, data, error } = response

                          if (error) {
                            setIsLoading(false)
                            return true
                          }

                          if (status === 200) {
                            if (data.plan_start == '' || data.plan_start == Empty) {
                              openNotificationWithIcon(
                                'error',
                                'Unable to copy because the task has not been added task information.',
                              )

                              getChartData()
                            } else {
                              getResultProjectList({
                                project_id: parseInt(idEditPRJ),
                                id_chart: item.id,
                                token: token,
                              })
                                .then(async (response) => {
                                  const { status, data, error } = response

                                  if (error) {
                                    setIsLoading(false)
                                    return true
                                  }
                                  if (status === 200) {
                                    const dataArray = {
                                      project_id_from: parseInt(idEditPRJ),
                                      project_id_to: parseInt(idEditPRJ),
                                      sprintflow_id: data.id,
                                      chart_id_from: item.id,
                                      chart_id_to: e.model.id,
                                      axis_x: e.item.model.x,
                                      axis_y: e.item.model.y,
                                    }

                                    try {
                                      copyTask({
                                        params: dataArray,
                                        token: token,
                                      }).then((response) => {
                                        const { status, data, error } = response
                                        let idCopy = ''
                                        idCopy = data
                                        if (status === 200) {
                                          getFlowCheckDate({
                                            project_id: parseInt(idEditPRJ),
                                            token: token,
                                          })
                                            .then(async (response) => {
                                              const { status, data, error } = response

                                              if (error) {
                                                setIsLoading(false)
                                                return true
                                              }
                                              setListErrorFlow(data.message)
                                              let flowComplete = ''

                                              if (data.err_check == 'Y') {
                                                data.message.map((item) => {
                                                  if (item.level == 2) {
                                                    if (
                                                      idCopy.sprintflow_id ==
                                                      item.level_id
                                                    ) {
                                                      setVisibleModalCheckSubtask(true)
                                                    }
                                                  }
                                                })
                                                setCheckChangeFlow('N')
                                                flowComplete = 'N'
                                              } else {
                                                setCheckChangeFlow('Y')
                                                flowComplete = 'Y'
                                              }

                                              const dataArray = {
                                                project_id: parseInt(idEditPRJ),
                                                complete_flow: flowComplete,
                                              }

                                              try {
                                                checkCompleteFlow({
                                                  params: dataArray,
                                                  token: token,
                                                }).then((response) => {
                                                  const { status, data, error } = response
                                                  if (status === 200) {
                                                    // getChartData()
                                                  }
                                                })
                                              } catch (error) {
                                                console.log(error)
                                              }

                                              if (status === 200) {
                                                setIsLoading(false)
                                              } else {
                                                setIsLoading(false)
                                                return true
                                              }
                                            })
                                            .catch((error) => {
                                              setIsLoading(false)
                                              console.error(error)
                                            })

                                          getChartData()
                                        }
                                      })
                                    } catch (error) {
                                      console.log(error)
                                    }

                                    setIsLoading(false)
                                  } else {
                                    setIsLoading(false)
                                    return true
                                  }
                                })
                                .catch((error) => {
                                  setIsLoading(false)
                                  console.error(error)
                                })
                            }
                          } else {
                            setIsLoading(false)
                            return true
                          }
                        })
                        .catch((error) => {
                          setIsLoading(false)
                          console.error(error)
                        })
                    }
                  })
                }

                if (checkCopy == true) {
                } else {
                  if (
                    e.item.model.shape == 'flow-rect' ||
                    e.item.model.shape == 'flow-rhombus'
                  ) {
                    setAddItem((prevState) => {
                      return {
                        ...prevState,
                        id_chart: e.item.model.id,
                        type_chart: 'item',
                        shape: e.item.model.shape,
                        color: e.item.model.color,
                        axis_x: e.item.model.x,
                        axis_y: e.item.model.y,
                        size: e.item.model.size,
                      }
                    })
                    setModalVision(true)
                  } else {
                    //เช็คว่า ให้กรอก start end ได้แค่อย่างละอัน
                    let repeatStartEnd = false

                    data.nodes.map((item) => {
                      if (item.shape == 'flow-circle') {
                        if (e.item.model.label == item.label) {
                          repeatStartEnd = true
                        }
                      }
                    })
                    if (repeatStartEnd == false) {
                      const dataArray = {
                        project_id: parseInt(idEditPRJ),
                        id_chart: e.item.model.id,
                        label: e.item.model.label,
                        type_chart: 'item',
                        shape: e.item.model.shape,
                        color: e.item.model.color,
                        axis_x: e.item.model.x,
                        axis_y: e.item.model.y,
                        size: e.item.model.size,
                      }

                      try {
                        postChart({
                          params: dataArray,
                          token: token,
                        }).then((response) => {
                          const { status, data, error } = response
                          if (status === 200) {
                            getChartData()
                          }
                        })
                      } catch (error) {
                        console.log(error)
                      }
                    } else {
                      openNotificationWithIcon(
                        'error',
                        'Start and End point can have 1 line per project.',
                      )
                      getChartData()
                    }
                  }
                }
              }
            } else if (e.action == 'update') {
              if (e.item.model.type == null) {
                const dataArray = {
                  project_id: parseInt(idEditPRJ),
                  id_chart: e.item.model.id,
                  label: e.item.model.label,
                  type_chart: 'line',
                  source: e.item.model.source,
                  sourceAnchor: e.item.model.sourceAnchor,
                  target: e.item.model.target,
                  targetAnchor: e.item.model.targetAnchor,
                }

                try {
                  updateChart({
                    params: dataArray,
                    token: token,
                  }).then((response) => {
                    const { status, data, error } = response
                    if (status === 200) {
                      getChartData()
                    }
                  })
                } catch (error) {
                  console.log(error)
                }
              } else {
                const dataArray = {
                  project_id: parseInt(idEditPRJ),
                  id_chart: e.item.model.id,
                  label: e.item.model.label,
                  type_chart: 'item',
                  shape: e.item.model.shape,
                  color: e.item.model.color,
                  axis_x: e.item.model.x,
                  axis_y: e.item.model.y,
                  size: e.item.model.size,
                }

                try {
                  updateChart({
                    params: dataArray,
                    token: token,
                  }).then((response) => {
                    const { status, data, error } = response
                    if (status === 200) {
                      getChartData()
                    }
                  })
                } catch (error) {
                  console.log(error)
                }
              }
            } else if (e.action == 'remove') {
              if (e.item.model.type == null) {
                const dataArray = {
                  project_id: parseInt(idEditPRJ),
                  id_chart: e.item.model.id,
                }
                try {
                  deleteChart({
                    params: dataArray,
                    token: token,
                  }).then((response) => {
                    const { status, data, error } = response
                    if (status === 200) {
                      getChartData()
                    }
                  })
                } catch (error) {
                  console.log(error)
                }
              } else {
                if (
                  e.item.model.flow_status == 'Done' ||
                  e.item.model.flow_status == 'In Progress' ||
                  e.item.model.can_delete == 'N'
                ) {
                  openNotificationWithIcon(
                    'error',
                    `Can't delete because this task status done or in progress.`,
                  )
                  getChartData()
                } else {
                  e.affectedItemIds.map((item) => {
                    const dataArray = {
                      project_id: parseInt(idEditPRJ),
                      id_chart: item,
                    }
                    try {
                      deleteChart({
                        params: dataArray,
                        token: token,
                      }).then((response) => {
                        const { status, data, error } = response
                        if (status === 200) {
                          getChartData()
                        }
                      })
                    } catch (error) {
                      console.log(error)
                    }
                  })
                }
              }
            }
          }
        } else {
          //ถ้าไม่เคยมี chart
          if (e.item.model.shape == 'flow-rect' || e.item.model.shape == 'flow-rhombus') {
            setAddItem((prevState) => {
              return {
                ...prevState,
                id_chart: e.item.model.id,
                type_chart: 'item',
                shape: e.item.model.shape,
                color: e.item.model.color,
                axis_x: e.item.model.x,
                axis_y: e.item.model.y,
                size: e.item.model.size,
              }
            })
            setModalVision(true)
          } else {
            const dataArray = {
              project_id: parseInt(idEditPRJ),
              id_chart: e.item.model.id,
              label: e.item.model.label,
              type_chart: 'item',
              shape: e.item.model.shape,
              color: e.item.model.color,
              axis_x: e.item.model.x,
              axis_y: e.item.model.y,
              size: e.item.model.size,
            }

            try {
              postChart({
                params: dataArray,
                token: token,
              }).then((response) => {
                const { status, data, error } = response
                if (status === 200) {
                  getChartData()
                }
              })
            } catch (error) {
              console.log(error)
            }
          }
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  const CheckClickTask = (e) => {
    getChart({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        let dataCC = data

        if (error) {
          return true
        }
        if (status === 200) {
          if (e.item != null) {

            //role คือ canNotEditProject
            // console.log(role, roleUser)
            if (role === true && roleUser !== 9) {
              dataCC.nodes.map((item) => {
                //เช็คว่า item ที่เข้ามาตรงกับ item ใน db มั้ย

                if (item.id == e.item.id) {
                  getResultProjectList({
                    project_id: parseInt(idEditPRJ),
                    id_chart: e.item.id,
                    token: token,
                  })
                    .then(async (response) => {
                      const { status, data, error } = response
                      if (error) {
                        props.setCode([])

                        setIsLoading(false)
                        return true
                      }

                      if (status === 200) {
                        props.setCode(data.code)
                        setIsLoading(false)
                        funcsetIdChart(e.item.id)
                        swithCaseTaskFLowFunction('addtask')
                        setCheckDecision(e.item.model.shape)
                        history.push(`/project/${id}/sprintflow/${e.item.id}/information`)
                      } else {

                        props.setCode([])
                        setIsLoading(false)
                        return true
                      }
                    })
                    .catch((error) => {
                      props.setCode([])
                      setIsLoading(false)
                      console.error(error)
                    })
                } else {
                  openNotificationWithIcon(
                    'error',
                    'Unable to access the task because the task was not saved.',
                  )
                }
              })
            } else {
              //เช็ค task ที่เข้ามา ว่าสามารถ click ไปได้หรือไม่
              if (
                e.item.model.shape == 'flow-rect' ||
                e.item.model.shape == 'flow-rhombus'
              ) {
                getChartTarget({
                  id_chart: e.item.model.id,
                  project_id: parseInt(idEditPRJ),
                  token: token,
                })
                  .then(async (response) => {
                    const { status, data, error } = response

                    if (error) {
                      setIsLoading(false)
                      return true
                    }

                    if (status === 200) {
                      let checkdiscision = ''
                      let datasource = []
                      data.map((item) => {
                        dataCC.nodes.map((item2) => {
                          if (item.source == item2.id) {
                            datasource.push(item2)
                          }
                        })

                        datasource.map((item) => {
                          if (item.shape == 'flow-rhombus') {
                            checkdiscision = 'mee'
                          }
                        })
                      })
                      if (datasource.length == 1 && checkdiscision == 'mee') {
                        datasource.map((item) => {
                          if (item.shape == 'flow-rhombus') {
                            getResultProjectList({
                              project_id: parseInt(idEditPRJ),
                              id_chart: item.id,
                              token: token,
                            })
                              .then(async (response) => {
                                const { status, data, error } = response

                                if (error) {
                                  setIsLoading(false)
                                  return true
                                }

                                if (status === 200) {
                                  if (data.plan_start == '' || data.plan_start == Empty) {
                                    openNotificationWithIcon(
                                      'error',
                                      'Please add information decision task',
                                    )
                                  } else {
                                    props.setCode(data.code)

                                    history.push(
                                      `/project/${id}/sprintflow/${e.item.id}/information`,
                                    )
                                    setIsLoading(false)
                                    funcsetIdChart(e.item.id)
                                    setStatusTask(data.flow_status)
                                    if (
                                      data.flow_status == 'Done' ||
                                      data.flow_status == 'In Progress' ||
                                      data.flow_status == 'Cancel'
                                    ) {
                                      props.setrolee(true)
                                    } else {
                                      props.setrolee(false)
                                    }
                                    swithCaseTaskFLowFunction('addtask')
                                    setCheckDecision(e.item.model.shape)
                                  }
                                } else {
                                  setIsLoading(false)
                                  return true
                                }
                              })
                              .catch((error) => {
                                setIsLoading(false)
                                console.error(error)
                              })
                          }
                        })
                      } else {
                        getResultProjectList({
                          project_id: parseInt(idEditPRJ),
                          id_chart: e.item.id,
                          token: token,
                        })
                          .then(async (response) => {
                            const { status, data, error } = response

                            if (error) {
                              props.setCode([])

                              setIsLoading(false)
                              return true
                            }
                            if (status === 200) {
                              props.setCode(data.code)

                              history.push(
                                `/project/${id}/sprintflow/${e.item.id}/information`,
                              )
                              setIsLoading(false)
                              funcsetIdChart(e.item.id)
                              setStatusTask(data.flow_status)
                              if (
                                data.flow_status == 'Done' ||
                                data.flow_status == 'In Progress' ||
                                data.flow_status == 'Cancel'
                              ) {
                                props.setrolee(true)
                              } else {
                                props.setrolee(false)
                              }
                              swithCaseTaskFLowFunction('addtask')
                              setCheckDecision(e.item.model.shape)
                            } else {
                              props.setCode([])
                              setIsLoading(false)
                              return true
                            }
                          })
                          .catch((error) => {
                            props.setCode([])
                            setIsLoading(false)
                            console.error(error)
                          })
                      }

                      setIsLoading(false)
                    } else {
                      getResultProjectList({
                        project_id: parseInt(idEditPRJ),
                        id_chart: e.item.id,
                        token: token,
                      })
                        .then(async (response) => {
                          const { status, data, error } = response

                          if (error) {
                            props.setCode([])

                            setIsLoading(false)
                            return true
                          }
                          if (status === 200) {
                            props.setCode(data.code)

                            history.push(
                              `/project/${id}/sprintflow/${e.item.id}/information`,
                            )
                            setIsLoading(false)
                            funcsetIdChart(e.item.id)
                            setStatusTask(data.flow_status)
                            if (
                              data.flow_status == 'Done' ||
                              data.flow_status == 'In Progress' ||
                              data.flow_status == 'Cancel'
                            ) {
                              props.setrolee(true)
                            } else {
                              props.setrolee(false)
                            }
                            swithCaseTaskFLowFunction('addtask')
                            setCheckDecision(e.item.model.shape)
                          } else {
                            props.setCode([])
                            setIsLoading(false)
                            return true
                          }
                        })
                        .catch((error) => {
                          props.setCode([])
                          setIsLoading(false)
                          console.error(error)
                        })
                      setIsLoading(false)
                      return true
                    }
                  })
                  .catch((error) => {
                    setIsLoading(false)
                    console.error(error)
                  })
              }
            }
          }
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  //sendback
  useEffect(() => {
    if (ModalVisionLine2 == true) {
      if (stateLine == 'Add') {
        form3.setFieldsValue({
          nameline: fieldNameLine,
        })
      } else if (stateLine == 'Add Review') {
        form3.setFieldsValue({
          nameline: 'Review',
        })
      }
    }
  }, [ModalVisionLine2])

  const checkSendBack = (e) => {
    let dataChart = ''
    getChart({
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          return true
        }
        dataChart = data
        if (status === 200) {
          let maxLine = 0

          getChartSource({
            id_chart: e.item.source.id,
            project_id: parseInt(idEditPRJ),
            token: token,
          })
            .then(async (response) => {
              const { status, data, error } = response

              if (error) {
                setIsLoading(false)
                return true
              }

              if (status === 200) {
                if (e.item.dataMap[e.item.source.id].shape == 'flow-rhombus') {
                  maxLine = 3
                } else if (e.item.dataMap[e.item.source.id].shape == 'flow-rect') {
                  maxLine = 2
                }

                if (data.length < maxLine) {
                  checkaddreview(dataChart.edges, e)
                } else {
                  getChartData()
                  openNotificationWithIcon('error', 'The task already has a review line.')
                }
              } else {
                checkaddreview(dataChart.edges, e)
              }
            })
            .catch((error) => {
              setIsLoading(false)
              console.error(error)
            })
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const checkaddreview = (data, e) => {
    let checkInTaskHaveReview = false
    let checkLineCountInTask = 0

    data.map((item) => {
      if (item.target == e.item.source.id) {
        if (item.label == 'Review') {
          checkInTaskHaveReview = true
        }
        checkLineCountInTask = checkLineCountInTask + 1
      }
    })
    if (checkInTaskHaveReview == true || checkLineCountInTask <= 2) {
      let state = []
      data.map((item) => {
        if (item.target == e.item.source.id) {
          //แม่ของมันคือ
          if (item.label != 'Review') {
            if (e.item.dataMap[item.source].id == e.item.target.id) {
              //เช็คว่าแม่ที่ชี้ไป สามารถชี้ไป ได้หรือไม่
              if (
                e.item.dataMap[e.item.target.id].shape == 'flow-circle' ||
                e.item.dataMap[e.item.target.id].shape == 'flow-rhombus'
              ) {
                state.push(1)
              } else {
                state.push(2)
              }
            } else {
              state.push(3)
            }
          } else {
          }
        }
      })
      let candosendback = false
      state.map((item) => {
        if (item == 2) {
          candosendback = true
        }
      })
      if (candosendback) {
        setCheckRealSendBack(true)
        setStateLine('Add Review')
        setAddLine((prevState) => {
          return {
            ...prevState,
            id_chart: e.item.model.id,
            type_chart: 'line',
            source: e.item.model.source,
            sourceAnchor: e.item.model.sourceAnchor,
            target: e.item.model.target,
            targetAnchor: e.item.model.targetAnchor,
          }
        })
        setCheckCanSendBack(true)
        setModalVisionLine2(true)
      } else {
        let err = 0
        state.map((item) => {
          console.log(item)
          if (item == 1) {
            openNotificationWithIcon(
              'error',
              'Unable to draw review line to find start point, end point and decision.',
            )
            getChartData()
          } else if (item == 3 || item == 4) {
            err = 7
          }
        })
        if (err == 7) {
          openNotificationWithIcon(
            'error',
            'The line cannot be drawn because the target is not the parent of the task.',
          )
          getChartData()
        }
      }
    } else {
      openNotificationWithIcon('error', 'Not supported.')
      getChartData()
    }
  }

  const [fullyCheckComplete, setFullyCheckComplete] = useState(false)

  const fucFullyCheckComplete = (data) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      complete_flow: data,
    }

    try {
      checkCompleteFlow({
        params: dataArray,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (status === 200) {
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (history.location.pathname.split('/').length == 4) {
      if (fullyCheckComplete != true && fullyCheckComplete != false) {
        // console.log(dataChart)
        if (dataChart?.length !== 0) {


          getFlowCheckDate({
          project_id: parseInt(idEditPRJ),
          token: token,
        })
          .then(async (response) => {
            const { status, data, error } = response

            if (error) {
              setIsLoading(false)
              return true
            }
            // console.log('when useEffect Flow.js', data)
            let flowComplete = ''

            if (data.err_check == 'Y') {
              flowComplete = 'N'
            } else {
              flowComplete = 'Y'
            }
            setListErrorFlow(data.message)
            if (flowComplete == 'Y') {
              fucFullyCheckComplete(fullyCheckComplete)
              setCheckChangeFlow(fullyCheckComplete)
            } else {
              fucFullyCheckComplete(flowComplete)
              setCheckChangeFlow(flowComplete)
            }

            if (status === 200) {
              setIsLoading(false)
            } else {
              setIsLoading(false)
              return true
            }
          })
          .catch((error) => {
            setIsLoading(false)
            console.error(error)
          })
        }

      }
    }
  }, [
    fullyCheckComplete,
    dataChart
  ])

  const checkChartComplete = (
    check,
    check2,
    check22,
    check5,
    check55,
    check7,
    check77,
  ) => {
    //check,checkchart = มี start และ end มั้ย, start มีเส้นออกมั้ย end มีเส้นเข้ามั้ย
    //check2,checkTaskHave200 = เช็คว่า task นั้น มีเส้นออกหรือเข้ามั้ย ผ่าน
    //check22,checkTaskHave400 = เช็คว่า task นั้น มีเส้นออกหรือเข้ามั้ย ไม่ผ่าน
    //รวมเป็น check3
    //check5,checkDecision200 =เช็คว่า decision นั้นมีเส้นออกทั้ง 2 เส้นมั้ย ผ่าน
    //check55,checkDecision400 = เช็คว่า decision นั้นมีเส้นออกทั้ง 2 เส้นมั้ย ไม่ผ่าน
    //รวมเป็น check6
    //check7,checkDecision2200 =เช็คว่า decision นั้นมีเส้นออกทั้ง 2 เส้นมั้ย ผ่าน
    //check77,checkDecision2400 = เช็คว่า decision นั้นมีเส้นออกทั้ง 1 เส้นมั้ย ไม่ผ่าน
    //รวมเป็น check8
    let check3 = false
    if (check2 == true && check22 == false) {
      check3 = true
    } else {
      check3 = false
    }

    let check6 = false
    if (check5 == true && check55 == false) {
      check6 = true
    } else {
      check6 = false
    }

    let check8 = false
    if (check7 == true && check77 == false) {
      check8 = true
    } else {
      check8 = false
    }

    let check4 = false

    if (checkHaveDecision == false) {
      check6 = true
      check8 = true
    }

    if (check == true && check3 == true && check6 == true && check8 == true) {
      check4 = 'Y'
    } else {
      check4 = 'N'
    }

    setFullyCheckComplete(check4)
    setFullyCheckCompleteInCommon(check4)
  }

  useEffect(() => {
    checkChartComplete(
      checkStartEnd,
      checkTask200,
      checkTask400,
      checkDecision200,
      checkDecision400,
      checkDecision2200,
      checkDecision2400,
    )
  }, [
    checkStartEnd,
    checkTask200,
    checkTask400,
    checkDecision200,
    checkDecision400,
    checkDecision2200,
    checkDecision2400,
  ])

  //deletesendback
  const onChangeCheckboxReview = (value) => {
    if (value.target.checked == true) {
      form3.setFieldsValue({
        nameline: 'Review',
      })
      setStateLine('Add Review')
      checkSendBack(dataLineSendBack)
    } else {
      form3.setFieldsValue({
        nameline: '',
      })
      setStateLine('Add')
      setCheckCanSendBack(true)
    }
  }

  const [checkCanLineName, setCheckCanLineName] = useState(true)

  const onChangeCheckLineName = (value) => {
    if (['approve', 'reject', 'review'].includes(lowerCase(value.target.value))) {
      setCheckCanLineName(false)
    } else {
      setCheckCanLineName(true)
    }
  }

  //modal
  const [dataLineSendBack, setDataLineSendBack] = useState()
  const [checkCanSendBack, setCheckCanSendBack] = useState(true)
  const [checkRealSendBack, setCheckRealSendBack] = useState(false)

  const handleOk = (values) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      id_chart: additem.id_chart,
      label: values.nametask,
      type_chart: 'item',
      shape: additem.shape,
      color: additem.color,
      axis_x: additem.axis_x,
      axis_y: additem.axis_y,
      size: '150*75',
    }
    const dataArray2 = {
      project_id: parseInt(idEditPRJ),
      id_chart: additem.id_chart,
      title: values.nametask,
      level: 1,
      level_id: 0,
    }
    try {
      postChart({
        params: dataArray,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (status === 200) {
          getChartData()
        }
        setModalVision(false)

        form.setFieldsValue({
          nametask: null,
        })
      })
    } catch (error) {
      console.log(error)
    }

    try {
      postSpintflowinit({
        params: dataArray2,
        token: token,
      }).then((res) => {
        const { status, data, error } = res
        if (status === 200) {
          getChartData()
        }
        setModalVision(false)

        form.setFieldsValue({
          nametask: null,
        })
        props.setCode(res.data.code)
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleOkLine = (values) => {
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      id_chart: addLine.id_chart,
      label: values.nameline,
      type_chart: 'line',
      source: addLine.source,
      sourceAnchor: addLine.sourceAnchor,
      target: addLine.target,
      targetAnchor: addLine.targetAnchor,
    }

    setModalVisionLine(false)
    setModalVisionLine2(false)
    setCheckRealSendBack(false)
    setCheckCanSendBack(true)

    if (
      values.nameline == 'Approve' ||
      values.nameline == 'Reject' ||
      stateLine == 'Add Review'
    ) {
    } else {
      setCookie('wordLine', values.nameline)
    }

    if (stateLine == 'Add' || stateLine == 'Add Review') {
      try {
        postChart({
          params: dataArray,
          token: token,
        }).then((response) => {
          const { status, data, error } = response

          if (status === 200) {
            getChartData()
          }

          form2.setFieldsValue({
            nameline: null,
          })
          form3.setFieldsValue({
            nameline: null,
          })
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      try {
        updateChart({
          params: dataArray,
          token: token,
        }).then((response) => {
          const { status, data, error } = response
          if (status === 200) {
            getChartData()
          }

          form2.setFieldsValue({
            nameline: null,
          })
          form3.setFieldsValue({
            nameline: null,
          })
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const handleCancel = () => {
    getChartData()
    setModalVision(false)
    form.setFieldsValue({
      nametask: null,
    })
  }

  const handleCancelLine = () => {
    getChartData()
    setModalVisionLine(false)
    form2.setFieldsValue({
      nameline: null,
    })
  }

  const handleCancelLine2 = () => {
    setCheckRealSendBack(false)
    getChartData()
    setCheckCanSendBack(true)
    setModalVisionLine2(false)
    form3.setFieldsValue({
      nameline: null,
    })
  }

  const modal = () => {
    return (
      <div>
        <Modal
          maskClosable={false}
          destroyOnClose={true}
          title={<span className="Modaltitle" style={{fontFamily: 'IBMPlexSansThaiBold'}}>Add Task</span>}
          visible={ModalVision}
          onOk={form.submit}
          onCancel={handleCancel}
          okText="Save"
          className="ModalAddTask"
        >
          <Form form={form} name="addtask" onFinish={handleOk}>
            <Form.Item
              name="nametask"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: word['addtask_information_Name'],
                },
              ]}
            >
              <Input
                style={{ borderRadius: 5 }}
                placeholder="Name"
                name="item"
                type="text"
                maxLength="60"
                size="large"
              ></Input>
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          maskClosable={false}
          destroyOnClose={true}
          title={<span className="Modaltitle" style={{fontFamily: 'IBMPlexSansThaiBold'}} >{stateLine} Line Name</span>}
          visible={ModalVisionLine}
          onOk={form2.submit}
          onCancel={handleCancelLine}
          okText="Save"
          className="ModalAddTask"
        >
          <Form form={form2} name="addlabel" onFinish={handleOkLine}>
            <Form.Item
              name="nameline"
              rules={[
                {
                  required: true,
                  message: word['addtask_information_Line_Name'],
                },
              ]}
            >
              <Radio.Group disabled={disableRadio}>
                <Radio className="fontradio" value={'Approve'}>
                  Approve
                </Radio>
                <Radio className="fontradio" value={'Reject'}>
                  Reject
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          maskClosable={false}
          destroyOnClose={true}
          title={<span className="Modaltitle" style={{fontFamily: 'IBMPlexSansThaiBold'}}>{stateLine} Line Name</span>}
          visible={ModalVisionLine2}
          onOk={form3.submit}
          onCancel={handleCancelLine2}
          okText="Save"
          className="ModalAddTask disable-page"
          okButtonProps={{ disabled: checkCanLineName ? !checkCanSendBack : true }}
        >
          <Form form={form3} name="addlabel2" onFinish={handleOkLine}>
            <Form.Item
              name="nameline"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: word['addtask_information_Line_Name'],
                },
              ]}
            >
              <Input
                onChange={onChangeCheckLineName}
                disabled={stateLine == 'Add Review' ? true : false}
                style={{ borderRadius: 5 }}
                placeholder="Name"
                name="line"
                type="text"
                maxLength="60"
                size="large"
              ></Input>
            </Form.Item>

            {/* deletesendback */}
            <div hidden={checkRealSendBack ? true : false}>
              <Checkbox onChange={onChangeCheckboxReview}>Review</Checkbox>
            </div>
          </Form>
        </Modal>

        <Modal
          maskClosable={false}
          className="ModalStatusOption"
          visible={visibleModalCheckSubtask}
          okText={'Close'}
          onOk={() => setVisibleModalCheckSubtask(false)}
          onCancel={() => setVisibleModalCheckSubtask(false)}
          cancelButtonProps={{ hidden: true }}
          destroyOnClose
        >
          <ExclamationCircleOutlined className="exclamationCircleOutlined" />
          <h2>Please change plan date of mandatory task</h2>
          <h2 style={{ margin: '0px' }}>or plan date of sub task.</h2>

          <h4 style={{ marginTop: '32px' }}>
            Unable to select a date that corresponds to the mandatory task or the subtask
            date must be in the range of the task.
          </h4>
        </Modal>
      </div>
    )
  }

  const [hiddenDelete, setHiddenDelete] = useState(false)
  const onClickFlow = (value) => {
    if (value.item != null) {
      if (
        value.item.model.flow_status == 'Done' ||
        value.item.model.flow_status == 'In Progress' ||
        value.item.model.can_delete == 'N'
      ) {
        setHiddenDelete(true)
      } else {
        setHiddenDelete(false)
      }
    }
  }

  const checkEditFlow = () => {
    if (role == true) {
    } else {
      return <FlowContextMenu hiddenDelete={hiddenDelete} />
    }
  }

  const previous = () => {
    swithCaseFunction('supportneed')
    history.push(`/project/${id}/supportneed`)
  }

  const checkPermission = () => {
    if (canSprintTaskFlow == false) {
      return (
        <div>
          <NoPermissionSprint />
          <Row justify="end" style={{ marginTop: 170 }}>
            <Button
              id="previoussprintflow"
              type="primary"
              className="BTN_Previous"
              onClick={() => previous()}
            >
              <LeftOutlined className="Icon-color" />
              Previous
            </Button>
          </Row>
        </div>
      )
    } else {
      return (
        <MapChartContainer>
          <GGEditor className="editor" style={{ height: '100%', width: '100%' }}>
            <Row type="flex" className="editorHd">
              <Col span={24}>
                <FlowToolbar dataChart={dataChart} />
              </Col>
            </Row>
            <Row type="flex" className="editorBd">
              <Col span={4} className="editorSidebar">
                <FlowItemPanel role={checkMobileView == true ? true : role} />
              </Col>
              <Col span={16} className="editorContent">
                <Flow
                  noEndEdge={false}
                  onAfterChange={(e) => onAfterChange(e, dataChart)}
                  onDoubleClick={(e) => CheckClickTask(e, dataChart)}
                  onContextMenu={(e) => onClickFlow(e)}
                  style={{
                    width: '100%',
                    height: '85%',
                  }}
                  className="flow"
                  data={dataChart}
                  bordered={true}
                />
                <CustomNodeRect />
                <CustomNodeRhombus />
              </Col>
              <Col span={4} className="editorSidebar">
                <EditorMinimap />
              </Col>
            </Row>
            {checkEditFlow()}

            <Row justify="end" style={{ marginTop: -106 }}>
              <Button
                id="previoussprintflow"
                type="primary"
                className="BTN_Previous"
                style={{ margin: 32 }}
                onClick={() => previous()}
              >
                <LeftOutlined className="Icon-color" />
                Previous
              </Button>
            </Row>
          </GGEditor>
          {
            listErrorflow?.length !== 0 && listErrorflow !== null
            // && ['4', '6'].includes(statusProject) 
            && (
              <div className='box-message-spritflow'>
                <Row className='rbms'>
                  <InfoCircleOutlined />
                  <span className='title-err-flow'>Incomplete Sprint Task</span>
                </Row>
                {listErrorflow?.map((e, edx) => <span className='item-text'>{edx + 1}.{e.title + '\t' + e.message}.</span>)}
              </div>
            )
          }
          {/* 4,6  status project*/}
          {modal()}
        </MapChartContainer>
      )
    }
  }

  return <div>{checkPermission()}</div>
}

export default TaskFlow
